import { create } from 'zustand';

export interface AppStore {
  version: string;
  channel: string;
  sapId: string;

  appLoaded: boolean;
  backendLoaded: boolean;
  collectorRegistered: boolean;

  socket: WebSocket | null;
  socketConnected: boolean;

  username: string;
  macAddress: string;
  computerName: string;

  setApp: (props: SetApp) => void;
  setSapId: (sapId: string) => void;
  setSocket: (socket: WebSocket | null) => void;
  setSocketConnection: (connected: boolean) => void;
}

interface SetApp {
  version: string;
  channel: string;
  backendLoaded: boolean;
  collectorRegistered: boolean;
  username: string;
  macAddress: string;
  computerName: string;
}

export const useAppStore = create<AppStore>()((set) => ({
  version: '1.0.0',
  channel: 'latest',
  sapId: '',
  username: 'n/a',
  macAddress: 'n/a',
  computerName: 'n/a',

  appLoaded: false,
  backendLoaded: false,
  collectorRegistered: false,

  socket: null,
  socketConnected: false,

  setApp: (props: SetApp) => set(() => ({ ...props, appLoaded: true })),
  setSapId: (sapId: string) => set(() => ({ sapId })),
  setSocket: (socket: WebSocket | null) => set(() => ({ socket })),
  setSocketConnection: (connected: boolean) => set(() => ({ socketConnected: connected }))
}));
